import { useState } from "react";
import { useNavigate } from "react-router-dom";
import api, { TOKEN_KEY } from "../api";
import { Mascot, MASC_ROBOT } from "../components/Mascots";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();
  const expired = new URLSearchParams(window.location.search).get("expired") === "1";

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setBusy(true);
    try {
      const r = await api.post("/auth/login", { email, password });
      localStorage.setItem(TOKEN_KEY, r.data.token);
      nav("/", { replace: true });
    } catch (e2) {
      setErr(e2.response?.data?.detail || "Accesso non riuscito");
    } finally { setBusy(false); }
  };

  return (
    <div className="login-wrap">
      <form className="login-card" onSubmit={submit} data-testid="login-form">
        <div className="login-brand"><Mascot className="brand-logo" svg={MASC_ROBOT} /> CRM Silvia Casali</div>
        <h1>Accedi</h1>
        <p className="muted" style={{ marginTop: -6 }}>Area riservata dello studio.</p>
        {expired && <p className="login-err" style={{ background: "rgba(250,204,21,.12)", color: "#facc15", border: "1px solid rgba(250,204,21,.35)", borderRadius: 8, padding: "8px 10px" }} data-testid="session-expired-msg">La sessione è scaduta: accedi di nuovo e ritroverai tutti i tuoi dati.</p>}
        <div className="field"><label>Email</label>
          <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} autoComplete="username" data-testid="login-email" />
        </div>
        <div className="field"><label>Password</label>
          <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} autoComplete="current-password" data-testid="login-password" />
        </div>
        {err && <p className="login-err" data-testid="login-error">{err}</p>}
        <button className="btn primary" type="submit" disabled={busy} data-testid="login-submit" style={{ width: "100%", marginTop: 8 }}>
          {busy ? "Accesso…" : "Entra"}
        </button>
      </form>
    </div>
  );
}
